export namespace AuthznApiUri {
  const BASE_URL = '/lcm/authzn/api';

  export const WHO_AM_I_URL = `${BASE_URL}/me`;

  export const GET_LOGIN_CONFIG_URL = `${BASE_URL}/loginconfig`;

  export const GET_ALL_CONFIG_PARAMS_URL = `${BASE_URL}/configparams`;
  export const CONFIG_PARAMS_BASE_URL = `${BASE_URL}/configparams`;

  export const GET_CONFIG_BY_NAME_URL = (name: string) =>
    `${BASE_URL}/configparams/${name}`;

  export const LOGIN_URL = `${BASE_URL}/login`;

  export const LOGOUT_URL = `${BASE_URL}/logout`;

  export const UPDATE_FIRST_BOOT_PASSWORD_URL = `${BASE_URL}/firstboot/updatepassword`;

  export const UPDATE_LOCAL_USER_PASSWORD_URL = `${BASE_URL}/users/updatepassword`;

  export const GET_ALL_TENANT_URL = `${BASE_URL}/idp/tenants/getall`;

  export const GET_ALL_TENANT_WRAPPER_URL = `${BASE_URL}/idp/tenants/fetchlist`;

  export const CREATE_TENANT_URL = `${BASE_URL}/idp/tenants/onboard`;

  export const TENANT_ASSOCIATE_PRODUCTS_URL = `${BASE_URL}/idp/tenants/associateproducts`;

  export const TENANT_ENABLE_MULTI_TENANCY_URL = `${BASE_URL}/idp/tenants/enablemultitenancy`;

  export const GET_TENANT_ASSOCIATION_PRODUCTS_URL = (tenantName: string) =>
    `${BASE_URL}/idp/tenants/onboard/fetchproducts/${tenantName}`;

  export const VALIDATE_TENANT_URL = `${BASE_URL}/idp/tenants/onboard/validate`;

  export const VALIDATE_TENANT_MIGRATION_URL = `${BASE_URL}/idp/tenants/migrate/validate`;

  export const GET_ALL_TENANT_ADMINS_URL = `${BASE_URL}/idp/tenants/gettenantadmins`;

  export const CREATE_TENANT_ADMIN_URL = `${BASE_URL}/idp/tenants/createlocaluser`;

  export const ASSIGN_TENANT_ADMIN_URL = `${BASE_URL}/idp/tenants/assigntenantadmin`;

  export const MIGRATE_TENANT_DIRECTORIES_URL = `${BASE_URL}/idp/tenants/migratetenantdirectories`;

  export const TENANT_REFERENCE_EXISTS_URL = `${BASE_URL}/idp/tenants/referenceexists`;

  export const DELETE_TENANT_URL = `${BASE_URL}/idp/tenants/delete`;

  export const GET_TENANT_PRODUCT_REFERENCES_URL = `${BASE_URL}/idp/tenants/productreferences`;

  export const GET_ALL_DIRECTORIES_URL = `${BASE_URL}/idp/dirConfigs/getall`;

  export const GET_CONNECTORS_URL = `${BASE_URL}/idp/connectors`;

  export const GET_CONNECTORS_WITH_DOMAIN_DETAILS_URL = `${BASE_URL}/idp/connectors/domain`;

  export const GET_CONNECTORS_WITH_IWA_DIR_URL = `${BASE_URL}/idp/connectors/directory/iwa/get`;

  export const ADD_AD_SEARCH_GROUPS_URL = `${BASE_URL}/idp/dirConfigs/searchgroups`;

  export const ADD_AD_TEST_CONNECTION_URL = `${BASE_URL}/idp/dirConfigs/validate`;

  export const ADD_AD_CREATE_DIRECTORY_CONFIG_URL = `${BASE_URL}/idp/dirConfigs`;

  export const ADD_AD_UPDATE_ATTRIBUTE_MAPPING_URL = `${BASE_URL}/idp/dirConfigs/userattrmappings`;

  export const ADD_AD_UPDATE_DOMAIN_SELECTION_URL = `${BASE_URL}/idp/dirConfigs/domains`;

  export const ADD_AD_UPDATE_USER_AND_GROUP_MAPPINGS_URL = `${BASE_URL}/idp/dirConfigs/syncprofile`;

  export const GET_AD_USER_DEFINITIONS_URL = `${BASE_URL}/idp/userattrdefinitions`;

  export const AD_SYNC_DRY_RUN_URL = `${BASE_URL}/idp/dirConfigs/syncprofile/dryrun`;

  export const GET_EXTENDED_AD_DIRECTORY_URL = `${BASE_URL}/idp/dirConfigs/get`;

  export const DELETE_AD_DIRECTORY_URL = `${BASE_URL}/idp/dirConfigs/delete`;

  export const TRIGGER_AD_SYNC_URL = `${BASE_URL}/idp/dirConfigs/syncprofile/sync`;

  export const UPDATE_AD_USER_DEFINITIONS_URL = `${BASE_URL}/idp/userattrdefinitions/update`;

  export const GET_AD_SYNC_ALERTS_URL = `${BASE_URL}/idp/dirConfigs/get/syncexecalerts`;

  export const GET_AD_SYNC_LOGS_URL = `${BASE_URL}/idp/dirConfigs/get/synclogs`;

  export const SEARCH_VIDM_USER_GROUP_URL = `${BASE_URL}/searchvidmusergrp`;

  export const GET_ALL_ROLES_URL = `${BASE_URL}/roles/external`;

  export const USERS_URL = `${BASE_URL}/users`;

  export const USER_URL = (vmid: string) => `${BASE_URL}/users/${vmid}`;

  export const GROUPS_URL = `${BASE_URL}/groups`;

  export const GROUP_URL = (vmid: string) => `${BASE_URL}/groups/${vmid}`;

  export const GET_ALL_USERS_URL = `${BASE_URL}/users/fromprovider`;

  export const GET_USER_BY_PROVIDER_ID_URL = (providerId: string) =>
    `${BASE_URL}/users/providerId/${providerId}`;

  export const GET_GROUP_BY_PROVIDER_ID_URL = (providerId: string) =>
    `${BASE_URL}/groups/providerId/${providerId}`;

  export const TRIGGER_CLUSTER_HEALTH_URL = `${BASE_URL}/vidmcluserhealth`;

  export const SET_AUTH_PROVIDER_URL = `${BASE_URL}/setauthprovider`;

  export const UPDATE_LCM_HOST_WITH_AUTH_PROVIDER = `${BASE_URL}/updlcmhostwithprovider`;

  export const GET_MIGRATION_SUPPORTED_ENVIRONMENTS_URL = `${BASE_URL}/idp/tenant/migration/supportedenvs`;
  export const GET_TENANT_MIGRATION_MAPPINGS = (
    sourceEnvironmentId: string,
    destEnvironmentId: string
  ) =>
    `${BASE_URL}/idp/tenant/migration/sourceenv/${sourceEnvironmentId}/destinationenv/${destEnvironmentId}/tenantmappings`;
  export const GET_MERGABLE_TARGET_TENANTS = (destEnvironmentId: string) =>
    `${BASE_URL}/idp/tenant/migration/destinationenv/${destEnvironmentId}/fetchalltenant`;

  export const GET_SOURCE_ENVIRONMENT_TENANT_DIRECTORIES = (
    sourceEnvironmentId: string,
    tenantName: string
  ) =>
    `${BASE_URL}/idp/tenant/migration/sourceenv/${sourceEnvironmentId}/tenant/${tenantName}/listdirectories`;

  export const MIGRATE_TENANT_SUBMIT_URL = `${BASE_URL}/idp/tenant/migration/migratetenant`;
  export const MERGE_TENANT_SUBMIT_URL = `${BASE_URL}/idp/tenant/migration/mergetenants`;
  export const REMEDIATE_CERTIFICATE_URL = `${BASE_URL}/idp/tenant/migration/addcertvalidationentry`;
}
